import React, { useCallback, useEffect, useState } from 'react';
import { Field, Form, Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {useDispatch} from 'react-redux';
import {showModal} from '../../../../redux/system/actions';
import ConfirmModal from '../../../common/modals/ConfirmModal';

const CANCEL_MODAL_ID = 'cancelModal';

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Certification name is required'),
  organization: Yup.string().required('Organization is required'),
  grantDate: Yup.date().required('Grant date is required')
});

function CertificationForm({ curriculumVitaeId, initialCertification, setEditingCertification, setAddingCertification, onSave, status }) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);
    
    const [certification, setCertification] = useState(
        initialCertification || {
            name: '',
            organization: '',
            licenseNumber: '',
            certificationUrl: '',
            grantDate: '',
            expiryDate: '',
            certificationDocument: null,
            curriculumVitaeId,
        }
    );

    const clearForm = () => {
        setEditingCertification(null);
        setCertification({
            name: '',
            organization: '',
            licenseNumber: '',
            certificationUrl: '',
            grantDate: '',
            expiryDate: '',
            certificationDocument: null,
            curriculumVitaeId,
        });
    };

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return d.toISOString().split('T')[0];
    };

    const handleCancel = () => {
        handleShowModal(CANCEL_MODAL_ID);
    };
    
      const confirmCancel = () => {
        setAddingCertification(false);
        setEditingCertification(null);
    };

    useEffect(() => {
        if (initialCertification) {
            setCertification({
                ...initialCertification,
                grantDate: formatDate(initialCertification.grantDate),
                expiryDate: formatDate(initialCertification.expiryDate) || '',
            });
        }
    }, [initialCertification]);

    return (
        <><Formik
            enableReinitialize={true}
            initialValues={certification}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
                const formData = new FormData();

                const sanitizedValues = {
                    ...values, expiryDate: values.expiryDate || ''
                };

                Object.keys(sanitizedValues).forEach((key) => {
                    if (key !== 'certificationDocument') {
                        formData.append(key, sanitizedValues[key]);
                    }
                });

                if (values.certificationDocument) {
                    formData.append('certificationDocumentFile', values.certificationDocument);
                    formData.append('documentName', values.certificationDocument.name);
                    formData.append('documentType', values.certificationDocument.type);
                }

                onSave(formData);
                clearForm();
                resetForm();
            } }
        >
            {() => (
                <Form>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="small">CERTIFICATION NAME *</label>
                            <Field name="name">
                            {({ field, meta }) => (
                                <input
                                {...field}
                                type="text"
                                className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''}`}
                                placeholder="Enter name"
                                />
                            )}
                            </Field>                            
                        <ErrorMessage name="name" component="div" className="text-danger small mt-1" />
                        </div>
                        <div className="col-md-6">
                            <label className="small">CERTIFICATION ORGANIZATION *</label>
                            <Field name="organization">
                            {({ field, meta }) => (
                                <input
                                {...field}
                                type="text"
                                className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''}`}
                                placeholder="Enter organization"
                                />
                            )}
                            </Field>                             
                            <ErrorMessage name="organization" component="div" className="text-danger small mt-1" />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label className="small">LICENSE NUMBER</label>
                            <Field name="licenseNumber" className="form-control" placeholder="Enter license number" />
                        </div>
                        <div className="col-md-6">
                            <label className="small">CERTIFICATION URL</label>
                            <Field name="certificationUrl" className="form-control" placeholder="Enter certification URL" />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label className="small">GRANT DATE *</label>
                            <Field name="grantDate">
                            {({ field, meta }) => (
                                <input
                                {...field}
                                type="date"
                                className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''}`}
                                placeholder="Enter phone number"
                                />
                            )}
                            </Field>                             
                            <ErrorMessage name="grantDate" component="div" className="text-danger small mt-1" />
                        </div>
                        <div className="col-md-6">
                            <label className="small">EXPIRY DATE</label>
                            <Field type="date" name="expiryDate" className="form-control" />
                        </div>
                    </div>

                    {/* <div className="row mt-3">
                        <div className="col-md-6">
                            <label className="small">ATTACHMENT FIELD (File Upload)</label>
                            <input
                                type="file"
                                className="form-control"
                                onChange={(e) => setFieldValue('certificationDocument', e.currentTarget.files[0])} />
                        </div>
                    </div> */}

                    <div className="mb-5 mt-4">
                        {initialCertification ? (
                            <div className="d-flex align-items-start">
                                <button className="btn btn-primary d-flex align-items-center mt-2 mr-3" type="submit">
                                    <i className="pe-7s-pen mr-2"></i>
                                    Update Certification
                                </button>
                                {status === 1 ? (
                                <button className="cancel-button d-flex mt-2" type="button" onClick={handleCancel}>
                                    <span>Cancel</span>
                                </button>
                                ) : (
                                <button className="cancel-button d-flex align-items-center mt-2" type="button" onClick={clearForm}>
                                    <span>Cancel</span>
                                </button>
                                )}
                            </div>
                        ) : (
                            <div className='d-flex'>
                                <button className="btn btn-primary d-flex mt-2 mr-3" type="submit">
                                    <i className="pe-7s-plus mr-2"></i>
                                    <span>Add Certification</span>
                                </button>
                                {status === 1 && (
                                    <button className="cancel-button d-flex mt-2" type="button" onClick={handleCancel}>
                                        <span>Cancel</span>
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </Form>
            )}
        </Formik>
        <ConfirmModal
            id={CANCEL_MODAL_ID}
            title="Are you sure you want to stop adding this certification?"
            message="This will cancel the form and return you to the overview. Do you wish to proceed?"
            onConfirm={confirmCancel} />
        </>
    );
}

export default CertificationForm;
